import { Box, Container } from '@mui/material';

import { useAppLayout } from '@/hooks/useAppLayout';
import BackgroundImg from '@/assets/images/Landing/hero-background.png';
import { HeroText } from './HeroSection/HeroText';

/**
 * Wave 3.5 — full-bleed brand hero.
 * Edge-to-edge image plane + scrim; brand/headline/CTA only in first viewport.
 */
export const LandingHeroSection = () => {
  const { headerHeight } = useAppLayout();

  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        minHeight: `calc(100vh - ${headerHeight}px)`,
        overflow: 'hidden',
        backgroundColor: 'var(--primary-navy)',
      }}
    >
      <Box
        aria-hidden
        sx={{
          position: 'absolute',
          inset: 0,
          overflow: 'hidden',
        }}
      >
        <Box
          component="img"
          alt=""
          src={BackgroundImg}
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: 'center',
            animation: 'tasteKenBurns 18s ease-out forwards',
            transformOrigin: 'center center',
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            background: 'var(--hero-scrim)',
          }}
        />
      </Box>

      <Container
        maxWidth="lg"
        sx={{
          position: 'relative',
          zIndex: 1,
          py: { xs: 8, md: 10 },
          px: { xs: 3, md: 4 },
        }}
      >
        <HeroText />
      </Container>

      <Box
        aria-hidden
        sx={{
          position: 'absolute',
          left: { xs: 24, md: 48 },
          bottom: 28,
          width: 72,
          height: 2,
          backgroundColor: 'rgba(247,249,251,0.55)',
          transformOrigin: 'left center',
          animation: 'tasteUnderline 1.1s 0.4s ease both',
        }}
      />
    </Box>
  );
};
